import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {scrollTo} from 'helpers/scroll-helper';
import {getText} from 'helpers/language-helper';
import TaskIntro from '../task-intro/task-intro';
import BranchingStoryMc from './branching-story-mc';
import BranchingStoryInfo from './branching-story-info';
import Button from 'components/ui/button/button';
import './branching-story.scss';

const BranchingStory = (props) => {
	const {
		languageId,
		playerTaskData,
		taskData,
		moduleData,
		deviceInfo, 
		updateLoggedTime,
		handleInstantTaskEffects, 
		handleCompleteTask
	} = props;

	let timeout = null;	

	/* Check if completed already */
	const isCompleted = (playerTaskData && playerTaskData.isCompleted === true ? true : false);

	/* Task id */
	const [taskId, setTaskId] = useState(null);

	/* Track story progres, points */
	const [storyArr, setStoryArr] = useState([]);
	const [points, setPoints] = useState(0);

	console.log('branching story step points: ', points);
	/* Next story step button */
	let showNextStoryStepBtn = false;
	const storyStepData = (storyArr.length > 0 
		? taskData.steps.find((s) => {return s.id === storyArr[storyArr.length - 1].stepId;})
		: null
	);
	if (storyStepData && storyStepData.type === 'info' && storyStepData.nextStepId && !storyStepData.isAutoContinue) {
		showNextStoryStepBtn = true;
	}

	/**
	 * Get points
	 * @returns {number} points
	 */
	const getPoints = () => {
		let points = 0;
		if (isCompleted) points = playerTaskData.points;
		return points;
	};

	/**
	 * Prepare story
	 * @returns {array} storyArrTemp
	 */
	const prepareStory = () => {
		let storyArrTemp = [];

		if (
			playerTaskData && 
			playerTaskData.isCompleted && 
			playerTaskData.storyArr && 
			playerTaskData.storyArr.length > 0
		) {
			storyArrTemp = [...playerTaskData.storyArr];
		} else {
			const firstStoryStepData = (taskData && taskData.steps && taskData.steps.length > 0 
				? taskData.steps[0] : null);
	
			if (firstStoryStepData) {
				storyArrTemp.push({stepId: firstStoryStepData.id});
			}			
		}
		return storyArrTemp;
	};

	/**
	 * Smooth scroll to story bottom
	 */
	const scrollToBottom = () => {
		var div = document.getElementById('story');
		if (div) {
			scrollTo(div, (div.scrollHeight - div.clientHeight), 0.1, null);
		}
	};

	/**
	 * Complete a story step
	 * @param {number} newPoints 
	 * @param {string} nextStoryStepId 
	 * @param {number} optionId 
	 */
	const handleCompleteStoryStep = (newPoints, nextStoryStepId, optionId = null) => {
		/* Update logged time */
		updateLoggedTime();
				
		/* Points */
		let totalPoints = points + newPoints;
		setPoints(totalPoints);

		/* Update step data */
		let newStoryArr = JSON.parse(JSON.stringify(storyArr));
		newStoryArr[newStoryArr.length - 1].points = newPoints;
		newStoryArr[newStoryArr.length - 1].optionId = optionId;
		newStoryArr[newStoryArr.length - 1].isCompleted = true;

		if (nextStoryStepId) {			
			/* Continue to next step */
			newStoryArr.push({stepId: nextStoryStepId});

			/* Check if completion of next step is automatic (with a delay) */
			const nextStoryStepData = taskData.steps.find((s) => {return s.id === nextStoryStepId;});
			if (nextStoryStepData && nextStoryStepData.type === 'info') {
				if (nextStoryStepData.nextStepId) {
					if (nextStoryStepData.isAutoContinue) {
					/* Auto-nav to next story step */
						timeout = setTimeout(() => {
							handleCompleteStoryStep(
								(nextStoryStepData.points ? nextStoryStepData.points : 0), 
								nextStoryStepData.nextStepId
							);
						}, 500);
					}
				} else {
					/* Auto-complete task */
					timeout = setTimeout(() => {
						completeTask(
							newStoryArr, 
							totalPoints + (nextStoryStepData.points ? nextStoryStepData.points : 0)
						);
					}, 500);
				}
			}
			
		} else {
			/* No next step: Complete task */
			completeTask(newStoryArr, points + newPoints);
		}
		
		/* Update story */
		setStoryArr(newStoryArr);
	};

	/**
	 * Complete task
	 * @param {array} newSelectedOptionIds 
	 */
	const completeTask = (newStoryArr, newPoints) => {
		/* Errors */
		const errors = 0;

		/* Save completed task */
		handleCompleteTask(
			'branching-story', 
			newPoints, 
			errors, 
			[],
			{storyArr: newStoryArr}
		);
	};

	/**
	 * Auto-scroll to bottom when story array is updated
	 */
	useEffect(() => {
		if (storyArr.length > 1) scrollToBottom();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [storyArr]);

	/**
	 * New branching story task, reset
	 */
	useEffect(() => {
		setTaskId(taskData.id);
		setPoints(getPoints());
		setStoryArr(prepareStory());
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [taskData.id]);

	/**
	 * Component mounted / will unmount
	 */
	useEffect(() => {
		/* Component mounted */

		return () => {
			/* Component will unmount */
			if (timeout) clearTimeout(timeout);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	return (
		<div className={'BranchingStory ' + deviceInfo.orientation}>
			{taskData.id === taskId && <div className="BranchingStory-content">
				<div id="taskIntro" className="BranchingStory-intro">
					<TaskIntro 
						languageId={languageId}
						moduleId={moduleData.id}
						text={taskData.text ? getText(taskData.text, languageId) : null}
						image={taskData.image}
						fileName={languageId + '-' + taskData.taskId}
					/>
				</div>
				<div id="story" className="BranchingStory-story">
					{storyArr.map((storyStep, index) => {
						const storyStepData = taskData.steps.find((s) => {return s.id === storyStep.stepId;});	
						let StoryStepComponent = BranchingStoryInfo;
						if (
							storyStepData && 
							storyStepData.type === 'multiple-choice'
						) StoryStepComponent = BranchingStoryMc;
						
						let storyStepClass = 'BranchingStory-step';
						let fadeLevel = null;
						if (index < storyArr.length - 1) {
							fadeLevel = (index < storyArr.length - 2 ? 'full' : 'half');
							storyStepClass += ' arrow ' + fadeLevel + 'FadeOut';
						}

						return (
							<div key={index} className={storyStepClass}>
								<StoryStepComponent 
									languageId={languageId}
									taskId={taskData.taskId}
									moduleId={moduleData.id}
									fadeLevel={fadeLevel}
									deviceInfo={deviceInfo}
									playerStoryStepData = {storyStep}
									storyStepData={storyStepData} 
									handleInstantTaskEffects={handleInstantTaskEffects}
									handleCompleteStoryStep={handleCompleteStoryStep}
								/>		
							</div>
						);
					})}
				</div>

				{/* Next story step button */}
				{showNextStoryStepBtn && <div className="BranchingStory-nextBtn">
					<Button 
						classes={['next', 'delay']} 
						onClick={() => {handleCompleteStoryStep(0, storyStepData.nextStepId);}} />
				</div>}		
			</div>}
		</div>
	);
};

BranchingStory.propTypes = {
	languageId: PropTypes.string.isRequired,
	playerTaskData: PropTypes.object,
	taskData: PropTypes.object.isRequired,
	moduleData: PropTypes.object.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	updateLoggedTime: PropTypes.func.isRequired,
	handleInstantTaskEffects: PropTypes.func.isRequired,
	handleCompleteTask: PropTypes.func.isRequired
};

export default BranchingStory;
